var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticClass:"figura-variable",style:({
    '--controlador-vis-figura-alto': `${_setup.simbolo.tamanio}px`,
    'min-width': `${_setup.simbolo.tamanioSimboloMayorMinimo}px`,
  }),attrs:{"width":_setup.simbolo.tamanioSimboloMayorMinimo,"height":_setup.simbolo.tamanio},domProps:{"innerHTML":_vm._s(_setup.simbolo.xml)}})
}
var staticRenderFns = []

export { render, staticRenderFns }